import { SearchListData } from '../SearchListContext';

/**
 * This hook returns the column that is currently being ordered by.
 */
export const useOrderByColumn = ({
  orderBy,
  allColumnList,
}: Pick<SearchListData, 'allColumnList' | 'orderBy'>) => {
  const key = orderBy?.key;

  return allColumnList.find(c => c.fieldName === key || c.key === key);
};
